<div class="cg-admin-shell">
  <app-admin-sidebar
    [menu]="menu()"
    [collapsed]="sidebarCollapsed()"
    [mobileOpen]="mobileNavOpen()"
    (mobileOpenChange)="mobileNavOpen.set($event)"
    (navSelected)="closeMobileNav()"
    (collapseToggle)="toggleSidebar()"
  />

  <div class="cg-admin-main-wrap" [class.sidebar-collapsed]="sidebarCollapsed()">
    <app-admin-topbar
      [pageTitle]="pageTitle()"
      [sidebarCollapsed]="sidebarCollapsed()"
      [user]="topbarUser()"
      (menuToggle)="toggleSidebar()"
      (logout)="logout()"
    />

    <main class="cg-admin-main cg-container">
      <router-outlet />
    </main>
  </div>

  <app-admin-toast-host />
  <app-admin-confirm-dialog-host />
</div>
